export default {
    components: {
        ElForm: () => import(/* webpackChunkName: "elements" */ "@components/forms/elements/ElForm")
    },

    data() {
        return {
            loading: false,
            success: false,
            server_error: null
        };
    },

    methods: {
        beforeSubmit() {
            this.loading = true;
            this.server_error = null;
            this.success = false;
        },

        handleSuccess() {
            this.loading = false;
            this.success = true;
            // setTimeout(() => {
            //     this.success = false;
            // }, 2000);
        },

        handleError(e) {
            this.loading = false;
            this.success = false;
            this.server_error = e;
        },
    }
};
